"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Switch_1 = __importDefault(require("./Switch"));
class SwitchContainer extends react_1.Component {
    constructor(props) {
        super(props);
        this.onToggle = () => {
            this.setState((prevState) => ({
                isEnabled: !prevState.isEnabled,
            }), () => {
                setTimeout(() => this.props.onChange && this.props.onChange(this.state.isEnabled), 200);
            });
        };
        this.state = {
            isEnabled: props.value || false,
        };
    }
    render() {
        const { isEnabled } = this.state;
        const { disabled, activeColor, inactiveColor, onHandleColor, offHandleColor, bgStyle, } = this.props;
        return (react_1.default.createElement(Switch_1.default, { isEnabled: isEnabled, onToggle: this.onToggle, disabled: disabled || false, activeColor: activeColor || "#080", inactiveColor: inactiveColor || "#888", onHandleColor: onHandleColor || "#fff", offHandleColor: offHandleColor || "#fff", bgStyle: bgStyle || {} }));
    }
}
SwitchContainer.defaultProps = {
    value: false,
    onChange: () => { },
    disabled: false,
    activeColor: "#080",
    inactiveColor: "#888",
    onHandleColor: "#fff",
    offHandleColor: "#fff",
    bgStyle: {},
};
exports.default = SwitchContainer;
//# sourceMappingURL=SwitchContainer.js.map